import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-dealer',
    templateUrl: './dealer.component.html',
    styleUrls: ['./dealer.component.scss']
})
export class DealerComponent implements OnInit {
    dealerForm!: FormGroup;
    products: string[] = [
        'Interactive Flat Panels (55", 65", 75", 86", 98", 105", 110")',
        'IFP Safety Shutters & All-in-One Smart Systems',
        'LMS Platform for Schools & Coaching',
        'K-12 Digital Content',
        'Accessories & Installation Support'
    ];

    constructor(private fb: FormBuilder) { }

    ngOnInit(): void {
        this.dealerForm = this.fb.group({
            fullName: ['', [Validators.required, Validators.minLength(3)]],
            companyName: ['', Validators.required],
            cityState: ['', Validators.required],
            phone: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
            email: ['', [Validators.required, Validators.email]],
            productInterest: [[], Validators.required],
            businessExperience: ['', Validators.required],
            message: ['']
        });
    }

    onSubmit(): void {
        if (this.dealerForm.valid) {
            console.log('Form Submitted', this.dealerForm.value);
            // Handle form submission logic here
        } else {
            this.dealerForm.markAllAsTouched();
        }
    }
}
